import { render } from "./index.vue?vue&type=template&id=059d3b68&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=059d3b68&lang=scss&scoped=true"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-059d3b68"],['__file',"src/views/CadastroDeModelos/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "059d3b68"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('059d3b68', __exports__)) {
    console.log('reload')
    api.reload('059d3b68', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=059d3b68&scoped=true", () => {
    console.log('re-render')
    api.rerender('059d3b68', render)
  })

}


export default __exports__